'use client';

import { c as _c } from "react/compiler-runtime";
import { ChefHat } from 'lucide-react';
import { motion } from 'motion/react';
export function AnimatedChefHat(t0) {
  const $ = _c(5);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 48 : t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "inline-flex"
    };
    t3 = {
      y: [0, -4, 0],
      rotate: [0, 3, -2, 0]
    };
    t4 = {
      duration: 5,
      repeat: Infinity,
      ease: "easeInOut"
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== size) {
    t5 = <motion.span style={t2} animate={t3} transition={t4}><ChefHat size={size} /></motion.span>;
    $[3] = size;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}